import type { ShareholdersTabSlug } from '@/services/shareholders/types';
import { getShareholdersTabPath } from '@/services/shareholders/utils';

import { SHAREHOLDERS_SECTION_CONTENT } from './shareholders';

import type { NavigationElementDataType } from '@/types';

type ShareholdersFooterLinkType = {
    slug: ShareholdersTabSlug;
    name: string;
    'data-test-id': string;
};

export const SHAREHOLDERS_FOOTER_COLUMN = {
    name: SHAREHOLDERS_SECTION_CONTENT.heading,
    'data-test-id': 'footer-shareholders-column',
};

const COLUMN_LINKS: ShareholdersFooterLinkType[] = [
    {
        slug: 'walne-zgromadzenia',
        name: 'Walne zgromadzenia',
        'data-test-id': 'footer-shareholders-meetings-link',
    },
    {
        slug: 'ogloszenia',
        name: 'Ogłoszenia',
        'data-test-id': 'footer-shareholders-announcements-link',
    },
    {
        slug: 'akcje-i-kapital',
        name: 'Informacje o akcjach i kapitale',
        'data-test-id': 'footer-shareholders-shares-link',
    },
    {
        slug: 'kontakt',
        name: 'Kontakt dla akcjonariuszy',
        'data-test-id': 'footer-shareholders-contact-link',
    },
];

const LEGAL_LINKS: ShareholdersFooterLinkType[] = [
    {
        slug: 'organy-spolki',
        name: 'Organy spółki',
        'data-test-id': 'footer-shareholders-boards-link',
    },
    {
        slug: 'statut-spolki',
        name: 'Statut spółki',
        'data-test-id': 'footer-shareholders-statute-link',
    },
];

const toPublishedLinks = (
    links: ShareholdersFooterLinkType[],
    publishedSlugs: ShareholdersTabSlug[],
): NavigationElementDataType[] =>
    links
        .filter(({ slug }) => publishedSlugs.includes(slug))
        .map(({ slug, ...link }) => ({
            ...link,
            href: getShareholdersTabPath(slug),
        }));

export const getShareholdersFooterLinks = (
    publishedSlugs: ShareholdersTabSlug[],
) => ({
    columnLinks: toPublishedLinks(COLUMN_LINKS, publishedSlugs),
    legalLinks: toPublishedLinks(LEGAL_LINKS, publishedSlugs),
});
